(function (angular) {
    'use strict';

    angular.module("branchReports")
        .controller("ReportsMessageDataCtrl", [
            "$q", "$scope", "$rootScope", '$stateParams', 'channelsData', 'growlService', 'messageDataService', '$uibModal', 'profileSchema', 'profilesService', 'profileHelper', 'NgTableParams', 'sharedChartService', 'jwtService', 'messageDataReportsFields', 'channelsProvider',
            function ($q, $scope, $rootScope, $stateParams, channelsData, growlService, messageDataService, $uibModal, profileSchema, profilesService, profileHelper, ngTableParams, sharedChartService, jwtService, messageDataReportsFields, channelsProvider) {

                $scope.fromOptions = {
                    showWeeks: false
                };

                $scope.toOptions = {
                    showWeeks: false
                };


                $scope.profileSchema = profileSchema;
                $scope.form = {};
                $scope.properties = [{
                    selector: "",
                    logic: "=~^",
                    value: ""
                }];
                $scope.profileFilter = {
                    useSpecificProfiles: false,
                    profileIds: []
                };


                $scope.channelsConfig = {
                    sms: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'message.channelOptions.sms.from', label: 'Originator' },
                            { id: 'profile.phoneNumber', label: 'Phone Number' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'message.channelData.sms.phoneNumberCountryCode', label: 'Country Code' },
                            { id: 'message.channelData.sms.segmentCount', label: 'Segments' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "delivered", label: "Delivered" },
                            { value: "queued", label: "Queued" },
                            { value: "failed", label: "Failed" }
                        ]
                    },

                    appMessaging: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profileId', label: 'Profile ID' },
                            { id: 'message.channelOptions.appMessaging.from.name', label: 'Team' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "delivered", label: "Delivered" },
                            { value: "sent", label: "Sent" },
                            { value: "read", label: "Read" }
                        ]
                    },

                    fbMessenger: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profile.fbMessengerId', label: 'Messenger ID' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "delivered", label: "Delivered" },
                            { value: "sent", label: "Sent" },
                            { value: "read", label: "Read" }
                        ]
                    },

                    email: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profile.email', label: 'Email Address' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "delivered", label: "Delivered" },
                            { value: "sent", label: "Sent" },
                            { value: "read", label: "Read" }
                        ]
                    },
                    twitterDm: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profile.twitterUsername', label: 'Twitter User Name' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "sent", label: "Sent" },
                            { value: "read", label: "Read" }
                        ]
                    },
                    whatsApp: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profile.phoneNumber', label: 'Phone Number' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "sent", label: "Sent" },
                            { value: "read", label: "Read" }
                        ]
                    },
                    rcs: {
                        cols: [
                            { id: 'submittedOn', label: 'Submitted On' },
                            { id: 'profile.phoneNumber', label: 'Phone Number' },
                            { id: 'message.metadata.comapiSystem', label: 'Source' },
                            { id: 'direction', label: 'Direction' },
                            { id: 'status', label: 'Status' }
                        ],
                        statuses: [
                            { value: "all", label: "All" },
                            { value: "sent", label: "Sent" },
                            { value: "delivered", label: "Delivered" },
                            { value: "read", label: "Read" }
                        ]
                    }
                };



                $scope.calendar = {
                    from: {},
                    to: {}
                };

                filterChannelData();

                $scope.availableChannels = channelsData.filter((c) => channelsProvider[c.id] ? channelsProvider[c.id].allowed : true);

                $scope.options = {
                    from: {},
                    to: {},
                    direction: 'all',
                    status: "all",
                    channel: undefined
                };


                $scope.optionsNotConfirmed = angular.copy($scope.options);

                $scope.optionsNotConfirmed.channel = sharedChartService.initialiseWatch($scope, "optionsNotConfirmed.channel", $stateParams.pickedApiSpaceId, "ReportsMessageDataCtrl");

                $scope.statuses = $scope.channelsConfig[$scope.optionsNotConfirmed.channel] ? $scope.channelsConfig[$scope.optionsNotConfirmed.channel].statuses : [{
                    value: 'all',
                    label: "All"
                }];

                $scope.messageData = [];

                $scope.open = function ($event, toOpen) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    toOpen.opened = !toOpen.opened;
                };

                var _selectedDateRange = null;
                Object.defineProperty($scope, 'selectedDateRange', {
                    get: function () {
                        return _selectedDateRange;
                    },
                    set: function (date) {
                        _selectedDateRange = date;
                        switch (date) {
                            case "Today":
                                $scope.optionsNotConfirmed.from = moment().startOf('day').toDate();
                                $scope.optionsNotConfirmed.to = moment().endOf('day').toDate();
                                break;
                            case "7Days":
                                $scope.optionsNotConfirmed.from = moment().startOf('week').toDate();
                                $scope.optionsNotConfirmed.to = moment().endOf('week').toDate();
                                break;
                            case "30Days":
                                $scope.optionsNotConfirmed.from = moment().startOf('month').toDate();
                                $scope.optionsNotConfirmed.to = moment().endOf('month').toDate();
                                break;
                            case "clear":
                                $scope.optionsNotConfirmed.to = new Date();
                                $scope.optionsNotConfirmed.from = null;
                                break;
                        }
                    }
                });

                $scope.selectedDateRange = "7Days";

                $scope.queryChange = function queryChange() {
                    if ($scope.channelsConfig[$scope.optionsNotConfirmed.channel]) {
                        $scope.statuses = [];
                        $scope.channelsConfig[$scope.optionsNotConfirmed.channel].statuses.forEach(function (status) {
                            $scope.statuses.push(status);
                        });
                    }
                };


                $scope.searchProfiles = function () {
                    var criteria = profileHelper.getExtension($scope.properties);
                    profilesService.getProfilesWithQueries($stateParams.pickedApiSpaceId, criteria)
                        .then(function (response) {
                            if (response.length > 20) {
                                $scope.tooManyProfiles = true;
                                return false;
                            }
                            $scope.profileFilter.profileIds = response.map(function (profile) {
                                return profile.id;
                            });
                            $scope.tooManyProfiles = false;
                            $scope.properties = profileHelper.getCriteria(criteria);
                            $scope.messageDataTable.reload();
                        }).catch(function (err) {
                            growlService.danger('Could not query profiles from server');
                        });
                };

                $scope.clearSearch = function () {
                    delete $scope.profileFilter.profileIds;
                    $scope.properties = [{
                        selector: "",
                        logic: "=~^",
                        value: ""
                    }];
                    $scope.messageDataTable.reload();
                }

                $scope.search = function search(skip, limit) {
                    if (!$scope.optionsNotConfirmed.channel) {
                        return $q.resolve({ data: [], count: 0 });
                    }
                    var options = angular.copy($scope.optionsNotConfirmed);

                    if (options.direction == 'all') {
                        options.direction = undefined;
                    }
                    if (options.status == 'all') {
                        options.status = undefined;
                    }
                    if (!moment.isMoment(options.from)) {
                        options.from = moment(options.from ? options.from : 0);
                    }
                    if (!moment.isMoment(options.to)) {
                        if (options.to) {
                            options.to = moment(options.to);
                        } else {
                            options.to = moment();
                        }
                    }

                    return messageDataService.getQueriedMessageHistory($stateParams.pickedApiSpaceId, options, skip || 0, limit || 10, $scope.profileFilter)
                        .then(function (result) {
                            $scope.options = angular.copy($scope.optionsNotConfirmed);
                            $scope.messageData = result.data;

                            return {
                                data: result.data,
                                count: result.count
                            };
                        })
                        .catch(function (error) {
                            $scope.optionsNotConfirmed = angular.copy($scope.options);
                            growlService.danger('Could not query data from server');
                            throw error;
                        });
                };


                $scope.exportData = function () {
                    var fields;
                    if (messageDataReportsFields[$scope.options.channel] && messageDataReportsFields[$scope.options.channel].length) {
                        fields = messageDataReportsFields.common.concat(messageDataReportsFields[$scope.options.channel]);
                    } else {
                        fields = messageDataReportsFields.common;
                    }

                    var displayedFields = $scope.channelsConfig[$scope.options.channel].cols.map(function (el) {
                        return el.id;
                    });

                    fields = _.union(fields, displayedFields);

                    var options = angular.copy($scope.optionsNotConfirmed);

                    if (options.direction == 'all') {
                        options.direction = undefined;
                    }
                    if (options.status == 'all') {
                        options.status = undefined;
                    }
                    if (!moment.isMoment(options.from)) {
                        options.from = moment(options.from ? options.from : 0);
                    }
                    if (!moment.isMoment(options.to)) {
                        if (options.to) {
                            options.to = moment(options.to);
                        } else {
                            options.to = moment();
                        }
                    }

                    var queryOptions = {
                        format: "csv",
                        fieldSeparator: ",",
                        fields: fields,
                        includeHeaders: true
                    };
                    $rootScope.$broadcast('fileDownload', { url: "/apispaces/" + $stateParams.pickedApiSpaceId + "/messages/history/export?" + messageDataService.getQueryString(options, null, null, $scope.profileFilter), token: jwtService.token, fileName: "messageDataExport.csv", data: queryOptions, httpVerb: "POST" });
                };

                $scope.getValueByPath = function getValueByPath(obj, string) {
                    let val = _.get(obj, string);
                    // Assume all messages without comapiSystem metadata are from the API
                    if (string === "message.metadata.comapiSystem" && val === undefined) {
                        val = "API";
                    }
                    return val;
                };


                $scope.viewContent = function (row) {

                    $uibModal.open({
                        templateUrl: 'components/reports/branch/templates/viewMesssageContentModal.html',
                        size: 'md',
                        resolve: {
                            messageData: [function () {
                                return row;
                            }]

                        },
                        controller: 'ViewMessageContentModalCtrl'
                    });

                }

                $scope.messageDataTable = new ngTableParams({
                    page: 1,            // show first page
                    count: 10,           // count per page
                    filter: $scope.profileFilter
                }, {
                    getData: function ($defer, params) {

                        var skip = (params.page() - 1) * params.count();
                        var limit = params.count();

                        $scope.search(skip, limit)
                            .then(function (result) {
                                $defer.resolve(result.data);
                                params.total(result.count);
                            });

                    },
                    filterDelay: 100
                });

                $scope.$watch('optionsNotConfirmed', function (newVal, oldVal) {
                    if (newVal) {
                        $scope.messageDataTable.reload();
                    }
                }, true);



                function filterChannelData() {
                    channelsData.forEach(function (channel) {

                        if (!$scope.channelsConfig[channel.id]) {

                            $scope.channelsConfig[channel.id] = {
                                cols: [
                                    { id: 'submittedOn', label: 'Date' },
                                    { id: 'profileId', label: 'Profile ID' },
                                    { id: 'message.metadata.comapiSystem', label: 'Source' },
                                    { id: 'direction', label: 'Direction' },
                                    { id: 'status', label: 'Status' }
                                ],
                                statuses: [
                                    { value: "all", label: "All" },
                                    { value: "delivered", label: "Delivered" },
                                    { value: "sent", label: "Sent" },
                                    { value: "read", label: "Read" }
                                ]
                            };
                        }
                    });

                    channelsData.sort(function (a, b) {
                        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
                    });


                }

            }
        ]);




})(window.angular);

